export class UpdateQuery {

        "detailId": Number;
        "queryId": Number;
        "updatedUserId": Number;
        "modifiedAnswer": Number;
        "status": String;
        "comments": String;

}